import styled, { css } from "styled-components";

// Colors
import { neutral } from "../../../style/colors";
import { media } from "../../../style/media";

const fontSize = ({ headerSize }) => {
  switch (headerSize) {
    case "small":
      return css`
        font-size: 11px;
        font-weight: 500;
      `;
    case "medium":
      return css`
        font-size: 13px;
        font-weight: 500;
      `;
    case "large":
      return css`
        font-size: 13px;
        font-weight: 600;
      `;
    default:
      return css`
        font-size: 11px;
        font-weight: 500;
      `;
  }
};

const Header = styled.div`
  color: ${neutral[700]};
  width: 100%;
  display: flex;
  position: relative;
  background: ${neutral[100]};
  user-select: none;
  margin-bottom: 16px;
  padding: 14px 16px;
  border-radius: 8px;
  border-bottom: 2px solid ${neutral[200]};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-left: ${({ labelSpace }) => (labelSpace ? "50px" : "0px")};
  ${fontSize};

  ${media.m`
    padding: 12px 8px;
  `}

  ${media.s`
    padding: 10px 6px;
  `}
`;

export default Header;
